<template>
  <div v-bind:class="classNameContainer">

    <div class="imagedisplayer">

      <div :class="'imageDisplay '" v-if="!!imageAct">

        <div class="buttonContainer">
          <button type="button" class="btn btn-primary btn-sm" v-on:click="imageplus">
            <i class="fa fa-plus"></i>
          </button>
          <button type="button" class="btn btn-primary btn-sm" v-on:click="imageminus">
            <i class="fa fa-minus"></i>
          </button>
          <button type="button" class="btn btn-primary btn-sm" v-on:click="imagerotateleft">
            <i class="fa fa-rotate-left"></i>
          </button>
          <button type="button" class="btn btn-primary btn-sm" v-on:click="imagerotateright">
            <i class="fa fa-rotate-right"></i>
          </button>
          <button type="button" class="btn btn-primary btn-sm" v-on:click="imageflipY">
            <i class="fa fa-arrows-v"></i>
          </button>
          <button type="button" class="btn btn-primary btn-sm" v-on:click="imageflipX">
            <i class="fa fa-arrows-h"></i>
          </button>
          <button type="button" class="btn btn-primary btn-sm" v-on:click="imageoriginal">
            <i class="fa fa-arrows-alt"></i>
          </button>
        </div>

        <div class="buttonContainerRight">
          <button type="button" class="btn btn-warning btn-sm" v-on:click="imageclose">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div :class="'imageActContainer'">
          <span>
          <img :src="imageAct" class="imageAct" :id="'imageId'+dataid" :style="'width:'+width+'px'"/>
          </span>
        </div>
      </div>

      <div v-if="!!pdfAct">

      </div>


      <div><span class="font-weight-bold">{{ $t('ImageDisplayer.images') }} :</span></div>

      <div class="imageelements">
        <template v-for="e in data">
          <span class="imageelement" v-if="e.mime!=='application/pdf'">
            <!--<a target="_blank" :href="baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company"  >-->
            <span class="leftTopIconContainer">
              <span class="leftTopIcon btn btn-primary btn-sm" v-if="haveToDownload">
                <!--:href="baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company"-->
                <a class="text-white" :href="baseUrl+apiUrl+'dlImage/'+e.name+'?id_company='+state.id_company">
                  <i class="fa fa-cloud-download"></i></a>
              </span>

              <span class="leftTopIcon btn btn-primary btn-sm">
              <a class="text-white" :href="(baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company)" target="_blank">
                <i class="fa fa-file"></i>
                <!--{{$t('global.open')}}-->
              </a></span>
            </span>


            <a v-on:click="clickImg(baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company)">
              <img class="imageelementX" :src="baseUrl+apiUrl+'getImage/'+'thumb_'+e.name+'?id_company='+state.id_company"/>
            </a>

            <div class="buttonContainerBottom" v-if="HelperRole.hasRights(state, [14],[16,20])">
              <button type="button" class="btn btn-danger btn-sm" v-on:click="imageDelete(e.id)">
                <i class="fa fa-times"></i>
              </button>
            </div>


          </span>
        </template>

      </div>

      <hr>
      <div><span class="font-weight-bold">{{ $t('ImageDisplayer.pdf') }} :</span>
      </div>
      <div class="fileelements">
        <template v-for="e in data">
          <span class="fileelement" v-if="e.mime==='application/pdf'">
            <!--{{baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company}}-->
            <span class="leftTopIconContainer">

              <span class="leftTopIcon btn btn-primary btn-sm" v-if="haveToDownload">
                <a class="text-white" :href="baseUrl+apiUrl+'dlImage/'+e.name+'?id_company='+state.id_company"><i
                  class="fa fa-cloud-download"></i></a></span>
                            <!--<object :data="baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company" type="application/pdf">-->
                            <!--<embed :src="baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company" type="application/pdf" />-->
                            <!--</object>-->

                            <!--<a target="_blank" :href="baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company"  >-->
                            <!--<span class="downloadIcon btn btn-primary btn-sm" v-if="haveToDownload"><a download class="text-white" :href="baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company"><i-->
                            <!--class="fa fa-cloud-download"></i></a></span>-->
                            <!--<a v-on:click="clickImg(baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company)">-->
                            <!--<img class="imageelement" :src="baseUrl+apiUrl+'getImage/'+'thumb_'+e.name+'?id_company='+state.id_company"/>-->
                            <!--</a>-->
              <span class="leftTopIcon btn btn-primary btn-sm">
              <a class="text-white" :href="(baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company)" target="_blank">
                <i class="fa fa-file"></i>
                <!--{{$t('global.open')}}-->
              </a></span>

            </span>
            <!--v-on:click="clickPdf(baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company)"-->
            <a  :href="(baseUrl+apiUrl+'getImage/'+e.name+'?id_company='+state.id_company)" target="_blank" >
              <img class="imageelementX" src="/img/pdf_logo.png"/>
            </a>


            <div class="buttonContainerBottom" v-if="HelperRole.hasRights(state, [14],[16,20])">
              <button type="button" class="btn btn-danger btn-sm" v-on:click="imageDelete(e.id)">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <br>


          </span>
        </template>

        <hr>

      </div>
    </div>

  </div>
</template>

<script>
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import HelperRole from '@/helper/HelperRole';


  export default {
    name: 'ImageDisplayer',
    props: {
      'hasError': {
        type: [Boolean, String],
        default: ''
      },
      dataid: {
        type: String,
        default: ""
      },
      datatype: {
        type: String,
        default: ""
      },
      className: {
        type: String,
        default: "",
      },
      classNameContainer: {
        type: String,
        default: "",
      },
      haveToDownload: {
        type: Boolean,
        default: false,
      },
      handler: {
        type: Function,
        default: function () {
        },
      },
      cbDataChange: {
        type: Function,
        default: function () {
        },
      },

    },
    data () {
      return {
        HelperRole: HelperRole,
        imageAct: "",
        pdfAct: "",
        width: 200,
        rotate: 0,
        scaleX: 1,
        scaleY: 1,
        data: [],
        state: {},
        baseUrl: "",
        apiUrl: ""
      }
    },
    mounted() {
      console.log("ImageDisplayer");
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.$eventBus.$on('globalImagesRefresh', this.globalImagesRefreshEventHandler);
      this.init();
    },
    beforeDestroy() {
      this.$eventBus.$off('globalImagesRefresh');
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.getImagesData()
        }
      },
      "dataid": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.getImagesData()
        }
      },
    },
    methods: {
      init() {
        const modul = this;
        modul.imageAct = "";
        modul.getImagesData()
        modul.baseUrl = Api.baseUrl;
        modul.apiUrl = Api.apiUrl;
      },
      globalImagesRefreshEventHandler (data) {
        const modul = this;
        modul.getImagesData();
      },
      clickImg(e, e2, e3) {
        const modul = this;
        modul.imageAct = e;
        modul.pdfAct = "";
      },
      clickPdf(e, e2, e3) {
        const modul = this;
        console.log(e)
        modul.imageAct = "";
        modul.pdfAct = e;
      },

      imageplus() {
        const modul = this;
        modul.width = modul.width * 1.5;
      },
      imageoriginal() {
        const modul = this;
        const width = modul.width;
        modul.width = 'auto';
        const img = document.getElementById('imageId' + modul.dataid);
        img.style = "";
        const defWidth = img.width;
        modul.width = defWidth;
      },
      imageclose() {
        const modul = this;
        modul.imageAct = "";
      },
      imagerotateleft() {
        const modul = this;
        const img = document.getElementById('imageId' + modul.dataid);
        modul.rotate = modul.rotate - 90;
        if (modul.rotate < 0) {
          modul.rotate = 270;
        }
        img.style.transform = 'rotate(' + modul.rotate + 'deg)';
      },
      imagerotateright() {
        const modul = this;
        const img = document.getElementById('imageId' + modul.dataid);
        modul.rotate = modul.rotate + 90;
        if (modul.rotate >= 320) {
          modul.rotate = 0;
        }
        img.style.transform = 'rotate(' + modul.rotate + 'deg)';
      },
      imageflipX() {
        const modul = this;
        const img = document.getElementById('imageId' + modul.dataid);
        modul.scaleX = modul.scaleX * -1;
        img.style.transform = 'scaleX(' + modul.scaleX + ')';
      },
      imageflipY() {
        const modul = this;
        const img = document.getElementById('imageId' + modul.dataid);
        modul.scaleY = modul.scaleY * -1;
        img.style.transform = 'scaleY(' + modul.scaleY + ')';
      },
      imageminus() {
        const modul = this;
        modul.width = modul.width / 1.5;
      },
      getImagesData(data) {
        const modul = this;
        const req = {};
        req.id = modul.dataid;
        req.id_company = modul.state.id_company;
        req.data = modul.datatype;
        console.log("modul.dataid");
        console.log(modul.dataid);
        if (modul.dataid) {
          Api.getImagesData(req).then(function (res) {
            if (res && res.result && res.data) {
              modul.data = res.data;
              if (typeof modul.cbDataChange) {
                modul.cbDataChange(modul.data)
              }
            }
          });
        }
      },
      imageDelete(id) {
        const modul = this;


        //// TODO  --- berakni a getimagesdata-t emit-tel!, hogy az összes újraszedje a képeket


      const fnCb = function () {
        const req = {};
        req.id = id;
        req.id_company = modul.state.id_company;
        req.data = modul.datatype;
        Api.imageDelete(req).then(function (res) {
          if (res && res.result && res.data) {
//            modul.data = res.data;
//            modul.getImagesData();
            modul.$eventBus.$emit('globalImagesRefresh', req);

          }
        });

      }
      modul.$eventBus.$emit('modal', {
      type: "confirm",
      msgTitle: "",
      tmsgTitle: "question",
      msgText: modul.$t("ImageDisplayer.imagedeletequestion"),
      tmsgText: "",
      fnCancel: function () {
        console.log('fnCancel')
      },
      fnConfirm: function () {
        console.log('fnConfirm')
        fnCb()
      }
    });

      },
    },
    components: {
      AlertInPage,
    }
  }
</script>
<style scoped>
  .downloadIcon {
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 1;
  }

  .leftTopIcon {
    position: relative;
    top: 5px;
    left: 5px;
    z-index: 1;
    margin: 0 5px 0 0;
  }

  .leftTopIconContainer {
    position: absolute;
    top: 0;
    left: 0;
  }

  .imagedisplayer {
    width: 100%;
    display: block;
  }

  .imageelements, .fileelements {
    width: 100%;
    display: inline-block;
  }

  .imageelement, .fileelement {
    display: inline-block;
    margin: 0 5px 5px 0;
    cursor: pointer;
    position: relative;
    top: 0;
    left: 0;
    min-width: 200px;
    min-height: 40px;
  }

  .fileelement {
    min-height: 150px;
    /*background-image: url("/img/pdf_logo.png");*/
    background-size: cover;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background-color: lightgrey;
  }

  .buttonContainer {
    display: block;
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 2;
    padding: 0 55px 0 0;
  }

  .buttonContainer .btn {
    margin: 0 1px 1px 0;

  }

  .buttonContainerRight {
    display: block;
    position: absolute;
    top: 5px;
    right: 22px;
    z-index: 2;
  }
  .buttonContainerBottom {
    display: block;
    position: absolute;
    bottom: 5px;
    left: 5px;
    z-index: 2;
  }

  .imageActContainer {
    display: block;
    margin-bottom: 10px;
    overflow: scroll;
    max-height: 600px;
    flex-grow: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .imageDisplay {
    position: relative;
    overflow: hidden;
    top: 0;
    left: 0;
    height: 400px;
  }

  .imageAct {
    max-width: none;
  }

</style>
